import { render, staticRenderFns } from "./getOffline.vue?vue&type=template&id=67c6fab0&scoped=true&"
import script from "./getOffline.vue?vue&type=script&lang=js&"
export * from "./getOffline.vue?vue&type=script&lang=js&"
import style0 from "./getOffline.vue?vue&type=style&index=0&id=67c6fab0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67c6fab0",
  null
  
)

export default component.exports